import type { RequestContext, UseCaseConfig, UseCaseKey } from '../types';

interface Props {
  ritm: string | null;
  requestId: string;
  context: RequestContext;
  jobOrder: UseCaseKey[];
  jobs: Record<string, UseCaseConfig>;
  onClose: () => void;
}

export function ConfirmationModal({ ritm, requestId, onClose }: Props) {
  return (
    <div className="modal-overlay open" role="dialog" aria-modal="true" aria-labelledby="modal-title">
      <div className="modal-content">
        <div className="modal-icon" aria-hidden>
          {ritm ? '✅' : '⏳'}
        </div>
        <h2 id="modal-title" className="modal-title">
          {ritm ? 'Request Submitted Successfully' : 'Request Queued'}
        </h2>
        <p className="modal-subtitle">
          {ritm
            ? 'Your ServiceNow RITM has been created and assigned to the AIOps platform team.'
            : 'Your request is queued for ServiceNow integration. You will receive an email once the RITM is created.'}
        </p>

        {ritm && (
          <div className="ritm-display">
            <div className="ritm-label">RITM Number</div>
            <div className="ritm-code">{ritm}</div>
          </div>
        )}

        <div className="tracking-id">
          Internal tracking ID: <code>{requestId}</code>
        </div>

        <div className="modal-actions">
          {ritm && (
            <a
              className="modal-btn primary"
              href={`https://lilly.service-now.com/sc_req_item.do?sysparm_query=number=${ritm}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Open in ServiceNow ↗
            </a>
          )}
          <button type="button" className="modal-btn secondary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
